module.exports = __webpack_public_path__ + "static/img/model-box-bg_light.66bda205.png";